import { Button, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const RouterErrorBoundary = () => {
  const error = useRouteError();

  let errorMessage = 'Něco se pokazilo...';
  let errorStatus: number | undefined;

  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText || error.data?.message || errorMessage;
    errorStatus = error.status;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }

  return (
    <Stack
      direction="column"
      spacing={3}
      sx={{
        height: '50vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: 2,
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 64, color: 'error.main' }} />

      {errorStatus && (
        <Typography variant="h3" color="error" fontWeight="bold">
          {errorStatus}
        </Typography>
      )}

      <Typography color="text.secondary" textAlign="center">
        <FormattedMessage
          id="errorBoundary.somethingWentWrong"
          defaultMessage="Něco se pokazilo..."
        />
      </Typography>

      <Typography variant="body2" color="text.secondary" textAlign="center">
        {errorMessage}
      </Typography>

      <Button variant="contained" onClick={() => window.location.reload()}>
        <FormattedMessage id="errorBoundary.reload" defaultMessage="Obnovit stránku" />
      </Button>

      {process.env.NODE_ENV === 'development' && error instanceof Error && error.stack && (
        <Stack
          sx={{
            mt: 2,
            p: 2,
            bgcolor: 'grey.100',
            borderRadius: 1,
            maxWidth: '80%',
            overflow: 'auto',
            maxHeight: 200,
          }}
        >
          <Typography
            variant="caption"
            component="pre"
            sx={{
              fontFamily: 'monospace',
              fontSize: '0.75rem',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
          >
            {error.stack}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default RouterErrorBoundary;
